import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <div className="bg-wellness-beige rounded-2xl p-8 md:p-12 max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-8 border border-wellness-darkBeige shadow-sm" data-id="element-44">
      <div className="flex-shrink-0 bg-white p-4 rounded-full shadow-md" data-id="element-45">
        <ShieldCheckIcon className="w-16 h-16 text-wellness-gold" data-id="element-46" />
      </div>
      <div className="text-center md:text-left" data-id="element-47">
        <h3 className="text-2xl font-bold mb-3 text-wellness-dark" data-id="element-48">
          Garantía de Satisfacción de 7 Días
        </h3>
        <p className="text-wellness-body leading-relaxed" data-id="element-49">
          Estamos tan seguros de que este programa transformará tu salud, que te
          ofrecemos una garantía incondicional. Si en 7 días no sientes una
          mejora en tu digestión, energía y bienestar general, te devolvemos el
          100% de tu dinero. Sin preguntas, sin complicaciones.
        </p>
      </div>
    </div>;
}